import React from "react";
import classes from "./userAccountPolicy.module.css";
import Footer from "../../components/footer";

const UserAccountPolicy = () => {
  return (
    <>
      <div className={classes.policyContainer}>
        <div className={classes.policyWrapper}>
          <h1 className={classes.policyTitle}>
            User Account Policy – Artist Next Door
          </h1>
          <p className={classes.lastUpdated}>Last Updated: 06th May 2025</p>

          <div className={classes.policyIntro}>
            <p>
              This <strong>User Account Policy</strong> governs the creation,
              use, and management of accounts on
              <strong> Artist Next Door</strong> ("Platform"). By registering an
              account, you agree to comply with these terms.
            </p>
          </div>

          <div className={classes.policySection}>
            <h2>1. Account Creation & Eligibility</h2>

            <div className={classes.subSection}>
              <h3>1.1 Registration Requirements:</h3>
              <ul className={classes.policyList}>
                <li>
                  Users must provide{" "}
                  <strong>accurate, current, and complete</strong> information
                  during signup.
                </li>
                <li>Accounts are personal and non-transferable.</li>
              </ul>
            </div>

            <div className={classes.subSection}>
              <h3>1.2 Account Types:</h3>
              <ul className={classes.policyList}>
                <li>
                  <strong>End Users:</strong> Book artists for events.
                </li>
                <li>
                  <strong>Artists:</strong> Offer services subject to Platform
                  approval.
                </li>
              </ul>
            </div>
          </div>

          <div className={classes.policySection}>
            <h2>2. Account Security & Responsibilities</h2>

            <div className={classes.subSection}>
              <h3>2.1 Password Protection:</h3>
              <ul className={classes.policyList}>
                <li>
                  Users are responsible for maintaining{" "}
                  <strong>confidentiality of login credentials</strong>.
                </li>
                <li>
                  Notify us immediately at{" "}
                  <a
                    href="mailto:support@artistnextdoor.in"
                    className={classes.emailLink}
                  >
                    support@artistnextdoor.in
                  </a>{" "}
                  if you suspect unauthorized access.
                </li>
              </ul>
            </div>

            <div className={classes.subSection}>
              <h3>2.2 Prohibited Actions:</h3>
              <ul className={classes.policyList}>
                <li>Sharing accounts with third parties.</li>
                <li>
                  Using bots, scrapers, or automated tools to access the
                  Platform.
                </li>
              </ul>
            </div>
          </div>

          <div className={classes.policySection}>
            <h2>3. Account Termination & Suspension</h2>

            <div className={classes.subSection}>
              <h3>3.1 By Artist Next Door:</h3>
              <ul className={classes.policyList}>
                <li>
                  We reserve the right to <strong>suspend or terminate</strong>{" "}
                  accounts for:
                  <ul className={classes.nestedList}>
                    <li>
                      Violations of our Terms of Service or Community
                      Guidelines.
                    </li>
                    <li>Fraudulent, abusive, or illegal activities.</li>
                  </ul>
                </li>
              </ul>
            </div>

            <div className={classes.subSection}>
              <h3>3.2 By User:</h3>
              <ul className={classes.policyList}>
                <li>Users may deactivate accounts via Platform settings.</li>
              </ul>
            </div>
          </div>

          <div className={classes.policySection}>
            <h2>4. Data Privacy</h2>
            <ul className={classes.policyList}>
              <li>
                Personal data is handled per our{" "}
                <a href="/privacy-policy" className={classes.policyLink}>
                  Privacy Policy
                </a>
                . Users may request data deletion per applicable laws.
              </li>
            </ul>
          </div>

          <div className={classes.policySection}>
            <h2>5. Policy Updates</h2>
            <ul className={classes.policyList}>
              <li>
                We may modify this policy with prior notice. Continued use
                constitutes acceptance.
              </li>
            </ul>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default UserAccountPolicy;
